module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 19
// module chunks = 24 25